import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const ListUserIndApi = createAsyncThunk('co-users/list', async ({ id }, { getState, rejectWithValue }) => {
  const { loginToken, loginTokenCoUser } = getState();
  const authToken = loginToken?.response?.token || loginTokenCoUser?.response?.token;
  try {
    const response = await fetch(
      `${ROOT_URL}/co-users/list/${id}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const ListUserIndividual = createSlice(
  {
    name: 'deleteGroup',
    initialState,
    reducers: {},
    extraReducers: {
      [ListUserIndApi.pending]: (state) => {
        state.isLoading = true;
      },
      [ListUserIndApi.fulfilled]: (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.response = action.payload;
      },
      [ListUserIndApi.rejected]: (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.error = action.payload;
      },
    },
  },
);

export default ListUserIndividual;
